import { API_BASE_URL } from "@/config";
import axios from "axios";

export async function sseRequestFormData(
    url,
    params,
    token,
    onSend,
    onReceive,
    onError,
    onDone,
    onAbort,
    signal,
) {
    await sseRequest(
        url,
        params,
        null,
        token,
        onSend,
        onReceive,
        onError,
        onDone,
        onAbort,
        signal,
    );
}

export async function sseRequestJson(
    url,
    params,
    token,
    onSend,
    onReceive,
    onError,
    onDone,
    onAbort,
    signal,
) {
    await sseRequest(
        url,
        JSON.stringify(params),
        { "Content-Type": "application/json" },
        token,
        onSend,
        onReceive,
        onError,
        onDone,
        onAbort,
        signal,
    );
}

export async function sseRequest(
    url,
    params,
    extraHeaders,
    token,
    onSend,
    onReceive,
    onError,
    onDone,
    onAbort,
    signal,
) {
    const response = await fetch(url, {
        method: "POST",
        headers: {
            ...extraHeaders,
            Authorization: token,
        },
        body: params,
        signal: signal,
    });

    if (!response.ok) {
        if (response.status === 401) {
            const refreshResponse = await axios.post(
                `${API_BASE_URL}/refresh-token`,
                {},
                { withCredentials: true },
            );
            const newAccessToken = refreshResponse.data;
            if (newAccessToken) {
                return sseRequest(
                    url,
                    params,
                    extraHeaders,
                    newAccessToken,
                    onSend,
                    onReceive,
                    onError,
                    onDone,
                    onAbort,
                    signal,
                );
            }
        }
        let errorData;
        try {
            errorData = await response.json();
        } catch {
            errorData = await response.text();
        }
        onError &&
            onError({
                status: response.status,
                statusText: response.statusText,
                body: errorData,
            });
        return;
    }

    onSend && onSend();

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");

    let buffer = "";
    function read() {
        reader
            .read()
            .then(({ done, value }) => {
                if (done) {
                    if (buffer.trim()) {
                        buffer.split("\n\n").forEach((event) => {
                            if (event.trim()) onReceive(parseSseEvent(event));
                        });
                    }
                    onDone && onDone();
                    return;
                }
                buffer += decoder.decode(value, { stream: true });
                let events = buffer.split("\n\n");
                buffer = events.pop();
                events.forEach((event) => {
                    if (event.trim()) onReceive(parseSseEvent(event));
                });
                read();
            })
            .catch((error) => {
                if (signal.aborted) {
                    onAbort && onAbort(error);
                } else {
                    onError && onError(error);
                }
            });
    }

    read();
}

function parseSseEvent(message) {
    let type = "message",
        start = 0;
    if (message.startsWith("event: ")) {
        start = message.indexOf("\n");
        type = message.slice(7, start);
    }
    start = message.indexOf(": ", start) + 2;
    let data = message.slice(start, message.length);

    return { type, data };
}
